import { useState } from "react";
import { Link } from "react-router-dom";
import SiteFooter from "@/components/paw/SiteFooter";
import PublicTopNav from "@/components/paw/PublicTopNav";
import { clearCompletedDraft } from "./draftPersistence";

const HOMEROOM_ARTWORK = "/desktop-homeroom.png";
const MOBILE_HOMEPAGE_ARTWORK = "/mobile-homepage-final.webp";
const GOLD_SEAL = "/gold-star-student-seal.png";

const MOBILE_LINKS = [
  { label: "Homeroom", to: "/" },
  { label: "Ask Miss Paw-some", to: "/ask" },
  { label: "Gifts", to: "/gifts" },
  { label: "Coming Soon", to: "/coming-soon" },
  { label: "Order", to: "/order?new=1" },
];

export default function HomePreview() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const startNewOrder = () => clearCompletedDraft();

  return (
    <div className="min-h-screen bg-[#F7F3EA]" data-testid="home-preview-app">
      <main className="mx-auto block w-full max-w-[520px] bg-[#F7F3EA] md:hidden" data-testid="paw-app-mobile">
        <div className="relative w-full">
          <img
            src={MOBILE_HOMEPAGE_ARTWORK}
            alt="Paw-some Reports mobile homepage"
            className="block h-auto w-full"
            data-testid="mobile-homepage-artwork"
          />
          <img src={GOLD_SEAL} alt="" aria-hidden="true" className="pointer-events-none absolute left-[59.5%] top-[68.2%] z-10 w-[22.1%]" />
          <img src={GOLD_SEAL} alt="" aria-hidden="true" className="pointer-events-none absolute left-[6.1%] top-[84.3%] z-10 w-[22.1%]" />

          <button
            type="button"
            onClick={() => setMobileMenuOpen((open) => !open)}
            className="absolute right-[3.5%] top-[0.7%] z-40 h-[3.8%] w-[10%] rounded-lg"
            aria-label={mobileMenuOpen ? "Close menu" : "Open menu"}
            aria-expanded={mobileMenuOpen}
            data-testid="mobile-home-menu-button"
          />

          {mobileMenuOpen && (
            <nav className="absolute right-[3%] top-[4.7%] z-50 w-[68%] overflow-hidden rounded-lg border border-[#DCCDB4] bg-[#F7F3EA] shadow-xl" aria-label="Mobile navigation">
              {MOBILE_LINKS.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  onClick={() => { if (link.label === "Order") startNewOrder(); setMobileMenuOpen(false); }}
                  className="block border-b border-[#DCCDB4] px-5 py-4 text-[18px] text-[#34465E] last:border-b-0"
                  style={{ fontFamily: "Georgia, serif" }}
                >
                  {link.label}
                </Link>
              ))}
            </nav>
          )}

          <Link
            to="/order?new=1"
            onClick={startNewOrder}
            className="absolute left-[5%] top-[77.1%] z-30 h-[7.2%] w-[90%] rounded-full"
            aria-label="Order Now"
            data-testid="mobile-order-cta-button"
          />
          <Link
            to="/contact"
            className="absolute bottom-[0.25%] right-[21%] z-20 h-[2.2%] w-[15%]"
            aria-label="Contact"
          />
        </div>
      </main>

      <div className="relative hidden w-full md:block">
        <PublicTopNav />
        <main className="relative mx-auto h-[753px] w-[1366px] overflow-hidden bg-[#F7F3EA]" data-testid="paw-app">
          <img src={HOMEROOM_ARTWORK} alt="Paw-some Reports Homeroom" className="absolute left-0 top-[-72px] h-[825px] w-[1366px] max-w-none" data-testid="approved-homeroom-artwork" />
          <img src={GOLD_SEAL} alt="" aria-hidden="true" className="pointer-events-none absolute left-0 top-[474px] z-10 w-[202px] max-w-none" />
          <img src={GOLD_SEAL} alt="" aria-hidden="true" className="pointer-events-none absolute left-[1113px] top-[595px] z-10 w-[150px] max-w-none" />
          <Link to="/" className="absolute left-[60px] top-[-2px] z-20 h-[235px] w-[500px]" aria-label="Homeroom" />
          <Link to="/order?new=1" onClick={startNewOrder} className="absolute left-[355px] top-[498px] z-20 h-[90px] w-[345px] rounded-full" aria-label="Order Now" />
        </main>
      </div>
      <div className="hidden md:block"><SiteFooter /></div>
    </div>
  );
}
